import { AsyncPipe } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScreenSizeService } from '@psu-pennstateit-swe/utils/responsive';

@Component({
  selector: 'app-toolbar-context',
  imports: [AsyncPipe],
  templateUrl: './toolbar-context.component.html',
  styleUrl: './toolbar-context.component.scss',
})
export class ToolbarContextComponent {
  routeData$ = inject(ActivatedRoute).data;
  isMobile = computed(() => this.screenSizeService.isHandset() && this.screenSizeService.isPortrait());
  private screenSizeService = inject(ScreenSizeService);
}
